
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/login/password",
      function () {
        return require("private-next-pages/login/password/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/login/password"])
      });
    }
  